import { graphql } from 'src/graphql';

import type { ResultOf } from 'src/graphql';

export const RoomNoteFields = graphql(`
  fragment RoomNoteFields on AskableVideoRoomNote @_unmask {
    _id
    _user_id
    time
    note
    displayName
    created
  }
`);

export const RoomNotes = graphql(
  `
    query RoomNotes($code: String!, $_room_id: ID!) {
      roomNotes(code: $code, _room_id: $_room_id) {
        ...RoomNoteFields
      }
    }
  `,
  [RoomNoteFields],
);

export type RoomNote = ResultOf<typeof RoomNoteFields>;
